import styled from "styled-components";

export const ChatbotGuideSelector = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  .header {
    color: #3e3e5b;
    padding: 20px;
    font-size: 25px;
    font-family: "Nunito Sans Light";
  }

  .selectors {
    box-sizing: border-box;
    padding: 10px 20px;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: auto;
    .process-selects {
      .process-selects__select {
        margin-bottom: 20px;
      }
    }
  }

  .footer {
    display: flex;
    justify-content: space-between;
    padding: 20px;
    background-color: #e9e9f5;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    .button-select {
      margin-left: 10px;
      width: 100%;
    }
  }
`;
